import React, { Component } from 'react';

import 'bulma/css/bulma.css';
import './css/app.css';
import './css/hamburger.css';
import './css/templates.css';
//import {getSettings} from './helpers';
import Header from './components/Header'
import Footer from './components/Footer'
import Content from './components/Content';
import {Image} from './helpers';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import { connect } from 'react-redux';
// JWD json web data
const addItemsToHead = (props) =>{
    const bgimg = props.app.settings.theme.navBg;
    document.head.insertAdjacentHTML("beforeend", `<style>.navbar,.footer {background-image:url('${Image(bgimg)}')}</style>`);  
}
const Loading = (props) =>{
      
       return <div className="loader-wrap">
           <div className="loader-box">
               <i className="loader"></i>
           </div>
       </div>
}
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
          form:{},
          cart:{}
        };
    }

    UNSAFE_componentWillMount(){
        if(!this.props.fetched){
            this.props.dispatch({type:"FETCH_DATA",dispatch:this.props.dispatch});
        }
    }
    changeState(e){
        if(e === "clear"){
            this.setState({form:{}});
        }else{
            let form = this.state.form;
            let name = e.target.name;
            let value = e.target.value
            form[name] = value;
            if(name === "phone1" || name === "phone2" || name === "phone3"){
                form.item2  = "1";
                form.item2 += form.phone1 || "";
                form.item2 += form.phone2 || "";
                form.item2 += form.phone3 || "";
            }
            this.setState({form:form});
        }
    }
    readState(){
        return this.state;
    }
           
    render() {
        if(this.props.fetched !== true)  return <Loading/>;
        if(this.props.fetched===true){
            addItemsToHead(this.props);
        }
        return this.props.app !==null?
            <section>
                <Header  {...this.props}/>
                <Content {...this.props} changeState={this.changeState.bind(this)} state={this.state}/>
                <Footer  {...this.props} />
            </section>
            : 
            <p>NOT FOUND</p>;
        
    }
}
class PrepApp extends Component {
    render() {
        const AppAlmostReady = (props)=>{
            const allprops = {...this.props, ...props};         
            return <App {...allprops} />           
        }
        return <Router>
                <Switch>
                    <Route path="/" exact={true} component={AppAlmostReady}/>
                    <Route path="/:page" exact={true} component={AppAlmostReady}/>
                    <Route path="/:page/:subpage" exact={true} component={AppAlmostReady}/>
                    <Route path="/:page/:subpage/:group" exact={true} component={AppAlmostReady}/>
                    <Route path="/:page/:subpage/:group/:item" exact={true} component={AppAlmostReady}/>
                </Switch>
            </Router> 
    }
}

const mapStateToProps = (state) => {
    return state;
    /*
   if(!("fetched" in state)){
        return {...state, fetched:false};
   }
   return state;*/
};
export default connect(mapStateToProps)(PrepApp);




// WEBPACK FOOTER //
// ./src/App.js